import bemCnFast from 'bem-cn-fast';

export default function bemCnFastWithModulesSupport(componentName, styles) {
  const bemCn = bemCnFast(componentName);
  if (!styles) {
    return bemCn;
  }
  return function bemCnBuilder(elementOrMods, mods) {
    const cn = bemCn(elementOrMods, mods);
    return (
      cn
        .split(' ')
        // this is a runtime dep of the components => cannot use arrow funcs here
        // eslint-disable-next-line prefer-arrow-callback, func-names
        .map(function(cls) {
          return styles[cls] || cls;
        })
        .join(' ')
    );
  };
}
